import ReactFlow, {
  ReactFlowProvider,
  Background,
  BackgroundVariant,
  ConnectionMode,
  MarkerType,
  type Node,
  type Edge,
} from 'reactflow';
import { TechNode, GroupNode, StickyNoteNode, TextNode } from '../features/diagrams';
import 'reactflow/dist/style.css';
import { EDGE_TYPES } from '../features/diagrams';

const nodeTypes = {
  techNode: TechNode,
  groupNode: GroupNode,
  stickyNote: StickyNoteNode,
  textNode: TextNode,
};

/**
 * A view-only React Flow canvas — the same node components the editor uses, with
 * all interaction disabled. Mirrors the public share/embed viewer so previews look
 * exactly like the real diagram. Fills its parent (give the parent a fixed height).
 */
export function DiagramReadOnlyCanvas({
  nodes,
  edges,
  className,
}: {
  nodes: Node[];
  edges: Edge[];
  className?: string;
}) {
  const viewOnly = nodes.map((n) => ({
    ...n,
    data: { ...n.data, onSnapshot: undefined },
    draggable: false,
    selectable: false,
    connectable: false,
  }));

  return (
    <ReactFlowProvider>
      <ReactFlow
        nodes={viewOnly}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={EDGE_TYPES}
        fitView
        fitViewOptions={{ padding: 0.2 }}
        minZoom={0.1}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        panOnDrag
        zoomOnScroll
        zoomOnPinch
        connectionMode={ConnectionMode.Loose}
        proOptions={{ hideAttribution: true }}
        className={className}
        defaultEdgeOptions={{
          type: 'smoothstep',
          style: { strokeWidth: 2 },
          markerEnd: { type: MarkerType.ArrowClosed },
        }}
      >
        <Background color="var(--border)" gap={20} variant={BackgroundVariant.Dots} />
      </ReactFlow>
    </ReactFlowProvider>
  );
}
